export default "__VITE_ASSET__BChl6qBz__"